// Config
import { drawerWidth } from "src/configs/themeConfig.js"

// material-ui
import { styled } from "@mui/material/styles"
import Drawer from "@mui/material/Drawer"

const openedMixin = theme => ({
  width: drawerWidth,
  left: 0,
  borderRadius: "12px",
  borderRight: "none",
  position: "sticky",
  top: 10,
  height: "calc(100vh - 24px)",
  maxHeight: "calc(100vh - 24px)",
  "& .MuiDrawer-paper": {
    // position: "relative",
    border: "none",
    height: "100%",
    maxHeight: "calc(100vh - 24px)"
  },
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: "hidden",
  overflowY: "hidden",
  color: "#fff",

  boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 50px"
})

const closedMixin = theme => ({
  left: 0,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  position: "sticky",
  borderRight: "none",
  overflowX: "hidden",
  width: 0,
  boxShadow: "none"
})

// ==============================|| DRAWER - MINI STYLED ||============================== //

const StyledDrawer = styled(Drawer, { shouldForwardProp: prop => prop !== "open" })(({ theme, open }) => ({
  width: drawerWidth,
  left: 0,
  top: "10px",
  height: "calc(100vh - 24px)",
  maxHeight: "calc(100vh - 24px)",
  boxShadow: theme.shadows[2],
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme)
  })
}))

export default StyledDrawer
